import Vue from 'vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { BootstrapVue, BootstrapVueIcons, VBModal } from 'bootstrap-vue' // bootstrap

Vue.use(BootstrapVue) // Install BootstrapVue
Vue.use(BootstrapVueIcons) // Optionally install the BootstrapVue icon components plugin
Vue.directive('b-modal', VBModal) // v-b-modal
